import { falsyToUndefined } from "../../../../lib/lang"
import { Admin, AdminRole, AdminSecuritySettings, CreateAdminUser, UpdateAdminUser } from "../../userTypes"

import { AdministratorFormValues } from "../administratorFormTypes"

/**
 * The parts of the create/update payload that are identical for every portal.
 *
 * Each portal page adds its own `type` discriminant and `*Details` object on top, which is what keeps
 * the payload typed without casts.
 */
export type CreateAdministratorFields = Readonly<{
    user: CreateAdminUser
    securitySettings: AdminSecuritySettings
    roles: AdminRole[]
}>

export type UpdateAdministratorFields = Readonly<{
    user: UpdateAdminUser
    securitySettings: AdminSecuritySettings
    roles: AdminRole[]
}>

function buildSecuritySettings(values: AdministratorFormValues): AdminSecuritySettings {
    return {
        allowToCreateAdmins: values.allowToCreateAdmins,
        restrictAccessToIpAddresses: values.restrictAccessToIpAddresses,
        ...(values.pinCode ? { pinCode: { value: values.pinCode } } : {}),
    }
}

export function toCreateAdministratorFields(values: AdministratorFormValues): CreateAdministratorFields {
    return {
        user: {
            username: falsyToUndefined(values.username),
            displayName: values.displayName,
            email: values.email,
            mobileNumber: falsyToUndefined(values.mobileNumber),
        },
        securitySettings: buildSecuritySettings(values),
        roles: values.roles,
    }
}

export function toUpdateAdministratorFields(values: AdministratorFormValues): UpdateAdministratorFields {
    return {
        user: {
            username: falsyToUndefined(values.username),
            displayName: values.displayName,
            email: values.email,
            mobileNumber: falsyToUndefined(values.mobileNumber),
            isActive: values.isActive,
        },
        securitySettings: buildSecuritySettings(values),
        roles: values.roles,
    }
}

export function toAdministratorFormValues(admin: Admin): AdministratorFormValues {
    return {
        username: admin.user.username ?? "",
        displayName: admin.user.displayName ?? "",
        email: admin.user.email ?? "",
        mobileNumber: admin.user.mobileNumber ?? "",
        allowToCreateAdmins: admin.securitySettings?.allowToCreateAdmins ?? true,
        restrictAccessToIpAddresses: admin.securitySettings?.restrictAccessToIpAddresses ?? "",
        pinCode: admin.securitySettings?.pinCode?.value ?? "",
        isActive: admin.user.isActive ?? true,
        resendInvitation: false,
        roles: admin.roles ?? [],
    }
}
